// 导入组件，组件必须声明 name
import AceIframeView from "./src/main";

// 为组件添加 install 方法，用于按需引入
AceIframeView.install = function (Vue) {
  Vue.component(AceIframeView.name, AceIframeView);
};

export default AceIframeView ;
